import { render, staticRenderFns } from "./PayrollKtuValues.vue?vue&type=template&id=459e5e78&scoped=true&"
import script from "./PayrollKtuValues.vue?vue&type=script&lang=js&"
export * from "./PayrollKtuValues.vue?vue&type=script&lang=js&"
import style0 from "./PayrollKtuValues.vue?vue&type=style&index=0&id=459e5e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e5e78",
  null
  
)

export default component.exports